import React from 'react';
import SearchCardItem from './SearchCardItem';

const SearchCardItems = ({
  category,
  items,
  onCheckBoxClick,
  single,
}) => (
  items.map((item, index) => (
    <SearchCardItem
      category={category}
      key={`searches_card_item_${item.id}`}
      onCheckBoxClick={onCheckBoxClick}
      search={item}
      single={single}
      upward={index > 4}
    />
  ))
);

export default SearchCardItems;
